import { AxiosReportLas } from '../config';

interface SendReportParams {
  data: unknown;
  empresa: number | string;
}

const MaterialsManagementService = {
  validateLogin: (login: string) =>
    AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
    }),
  sendReport: ({ data, empresa }: SendReportParams) =>
    AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/GestaoMateriais',
      data,
      headers: {
        'Content-Type': 'application/json',
        EmpresaId: empresa,
      },
    }),
};

export { MaterialsManagementService };
